/**
 * Created by alvaroescarcha on 29/9/17.
 */

/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    /**
     * Factory callback type
     */
    declare type SystemAlarmsDirectiveFactoryCb = ($rootScope: Services.IFlexSettings,
                                             $interval: ng.IIntervalService,
                                             $timeout: ng.ITimeoutService,
                                             $window: ng.IWindowService,
                                             stompService: Services.StompService,
                                             alarmsService: Services.AlarmsService,
                                             userService: Services.UserService,
                                             aclAservice: Services.AclService,
                                             flexCollectorService: Services.FlexCollectorService) => SystemAlarmsDirective;

    /**
     * Custom scope
     */
    export interface ISystemAlarmsDirectiveScope extends ng.IScope {
        critical: number;
        alarmSubscription: Services.IEventSubscription;
        alarmSubscriptionBulkConfirm: Services.IEventSubscription;
        alarmSubscriptionBulkConfirmAll: Services.IEventSubscription;
        isAdmin: boolean;
        systemConsoleUrl: string;
        showCounter: boolean;
    }

    /**
     * Bar directive
     */
    export class SystemAlarmsDirective implements ng.IDirective {
        public static $name: string = "systemAlarms";

        public link: (scope: ISystemAlarmsDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'AE';
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/system-alarms-directive.html';

        /**
         * Factory for the directive
         */
        public static Factory(): SystemAlarmsDirectiveFactoryCb {
            let directive: SystemAlarmsDirectiveFactoryCb = ($rootScope: Services.IFlexSettings,
                                                       $interval: ng.IIntervalService,
                                                       $timeout: ng.ITimeoutService,
                                                       $window: ng.IWindowService,
                                                       stompService: Services.StompService,
                                                       alarmsService: Services.AlarmsService,
                                                       userService: Services.UserService,
                                                       aclService: Services.AclService,
                                                       flexCollectorService: Services.FlexCollectorService) => {
                return new SystemAlarmsDirective($rootScope, $interval, $timeout, $window, stompService, alarmsService, userService,
                    aclService, flexCollectorService);
            };
            directive.$inject = ['$rootScope', '$interval', '$timeout', '$window', 'stompService', 'alarmsService', 'userService',
                'aclService', 'flexCollectorService'];
            return directive;
        }

        /**
         * Constructor
         */
        constructor(private $rootScope: Services.IFlexSettings,
                    private $interval: ng.IIntervalService,
                    private $timeout: ng.ITimeoutService,
                    private $window: ng.IWindowService,
                    private stompService: Services.StompService,
                    private alarmsService: Services.AlarmsService,
                    private userService: Services.UserService,
                    private aclAservice: Services.AclService,
                    private flexCollectorService: Services.FlexCollectorService) {

            SystemAlarmsDirective.prototype.link = ($scope: ISystemAlarmsDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                this.initVariables($scope);
                this.$timeout( () => {
                    this.loadAlarms($scope);
                }, 1000);
                this.initSubscriptions($scope, stompService);

                $scope.$on('$destroy', () => {
                    if ($scope.alarmSubscription)
                        stompService.unregister($scope.alarmSubscription);

                    if ($scope.alarmSubscriptionBulkConfirm)
                        stompService.unregister($scope.alarmSubscriptionBulkConfirm);

                    if ($scope.alarmSubscriptionBulkConfirmAll)
                        stompService.unregister($scope.alarmSubscriptionBulkConfirmAll);

                });

            };
        }

        private loadAlarms($scope: ISystemAlarmsDirectiveScope): void {
            this.alarmsService.countCriticalFlexAlarms(true).then((response: Models.ICriticalCountResponse) => {
                $scope.critical = response.count;
            }).catch((reason: ngCustom.IReason) => {
                console.log(reason);
            });
        }

        private initVariables($scope: ISystemAlarmsDirectiveScope): void {
            this.userService.loadCurrentUser().then((user: Models.User) => {
                // Show "confirm all alarms" only if the user is admin
                $scope.isAdmin = user.authorities.some((auth: Models.IAuthority) => {
                    return auth.authority === 'ROLE_ADMIN' || auth.authority === "ROLE_ORGANIZATION_ADMIN";
                });

                this.aclAservice
                    .canRead("io.epiclabs.flex.api.WebApplication", 20)
                    .then((can: boolean) => {
                        $scope.systemConsoleUrl = can || $scope.isAdmin ? "#!/admin/system/system-alarms" : "#";
                        $scope.showCounter = can;
                    });
            });
        }

        private initSubscriptions($scope: ISystemAlarmsDirectiveScope, stompService: Services.StompService): void {
            $scope.alarmSubscription = stompService.register(Models.ALARMS_COMPONENT, Models.CREATE_OPERATION,
                (flexEvent: Models.IFlexEvent) => {
                    if (flexEvent.data.system && (flexEvent.data.level === 0 || flexEvent.data.level === 8)) {
                        $scope.critical++;
                    }
                });

            $scope.alarmSubscriptionBulkConfirm = stompService.register(Models.ALARMS_COMPONENT, Models.BULK_CONFIRM_OPERATION,
                () => {
                    this.loadAlarms($scope);
                });

            $scope.alarmSubscriptionBulkConfirmAll = stompService.register(Models.ALARMS_COMPONENT, Models.BULK_CONFIRM_ALL_OPERATION,
                () => {
                    this.loadAlarms($scope);
                });
        }
    }
}

